export default __webpack_public_path__ + "static/media/search.7cbce6ee.svg";